import React from 'react';
import { Pagination } from 'oskcomponents';
import { connect } from 'react-redux';
import { DEFAULT_VISIBLE_PAGE_SIZE } from '~/pagination';
import { selectDetectionsByAsset, setDetectionPage } from '~/redux/modules/monitor/app';
import { AppDispatch, RootState } from '~/redux/store';

export type DetectionPaginatorProps = {
    assetId: number;
    totalDetections: number;
    currentPage: number;
    changePage: (pageNumber: number) => void;
};

export const DetectionPaginator = ({ changePage, totalDetections, currentPage }: DetectionPaginatorProps) => {
    return (
        <Pagination onChange={changePage} count={totalDetections} offset={currentPage * DEFAULT_VISIBLE_PAGE_SIZE} />
    );
};

const mapStateToProps = (state: RootState, ownProps: Partial<DetectionPaginatorProps>) => {
    const { assetId } = ownProps;

    return {
        totalDetections: selectDetectionsByAsset(state, assetId ?? -1).length,
        currentPage: state.monitor.app.detectionPageByAsset[assetId ?? -1] ?? 0,
    };
};

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: Partial<DetectionPaginatorProps>) => {
    const { assetId } = ownProps;

    return {
        changePage: (pageNumber: number) => {
            dispatch(setDetectionPage(assetId ?? -1, pageNumber));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetectionPaginator);
